/* file description */
import React, { FC, useEffect, useState, useRef } from 'react';
import { Upload, Button, UploadProps, message } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import {
  getPolicy,
  policyUpload,
  upload,
} from '@/common/asset-apis/assetModel';
import { UploadRenderItemProps } from './type';
import { COLUMN_FROM } from '../consts';
import memo from '../../component/memo';

export const UploadRenderItem: FC<UploadRenderItemProps> = ({
  value,
  onChange,
  field,
  FetchAPI,
  form,
  config,
  columnFrom,
  disabled,
}) => {
  const uploadHost = useRef<string>('');
  const uploadUrl = useRef<string>('');
  const [fileList, setFileList] = useState<UploadProps['defaultFileList']>([]);

  // 编辑时初始化
  useEffect(() => {
    if (value) {
      const fileName = value?.match(/\/([^/?#]+)[^/]*$/)?.[1] || value;
      setFileList([
        {
          uid: value,
          name: fileName,
          status: 'done',
          url: value,
        },
      ]);
    } else {
      setFileList([]);
    }
  }, [value]);

  const handleUpload = (file: any) => {
    // // 获取签名
    // getPolicy(FetchAPI, file.file.name).then((res) => {
    //   const {
    //     xamzAlgorithm,
    //     xamzCredential,
    //     policy,
    //     xamzSignature,
    //     xamzDate,
    //     host,
    //   } = res;
    //   uploadHost.current = host;
    //   const formData = new FormData();
    //   formData.append('key', file.file.name);
    //   formData.append('x-amz-algorithm', xamzAlgorithm);
    //   formData.append('x-amz-credential', xamzCredential);
    //   formData.append('policy', policy);
    //   formData.append('x-amz-signature', xamzSignature);
    //   formData.append('x-amz-date', xamzDate);
    //   formData.append('file', file.file);
    //   // 上传文件
    //   policyUpload(FetchAPI, host, formData).then(() => {
    //     file.onProgress({ percent: 100 });
    //     file.onSuccess();
    //   });
    // });
    upload(FetchAPI, file).then((res) => {
      uploadUrl.current = res;
      file.onProgress({ percent: 100 });
      file.onSuccess();
    });
  };

  const handleChange: UploadProps['onChange'] = (info) => {
    const values: Record<any, any> = {};
    switch (info.file.status) {
      case 'done':
        onChange?.(uploadUrl.current);
        if (field?.bizConfig?.fileName) {
          if (columnFrom === COLUMN_FROM.FORM) {
            values[field?.bizConfig?.fileName] = info.file.name;
            form.setFieldsValue(values);
          }
          if (columnFrom === COLUMN_FROM.TABLE) {
            const tableKey = config.rowIndex;
            values[tableKey] = {};
            values[tableKey][field?.bizConfig?.fileName] = info.file.name;
            form.setFieldsValue(values);
          }
        }
        break;
      case 'removed':
        onChange?.(null);
        if (field?.bizConfig?.fileName) {
          if (columnFrom === COLUMN_FROM.FORM) {
            values[field?.bizConfig?.fileName] = '';
            form.setFieldsValue(values);
          }
          if (columnFrom === COLUMN_FROM.TABLE) {
            const tableKey = config.rowIndex;
            values[tableKey] = {};
            values[tableKey][field?.bizConfig?.fileName] = '';
            form.setFieldsValue(values);
          }
        }
        break;
      default:
        break;
    }
    setFileList([...info.fileList]);
  };

  const checkFormats = (file: File) => {
    const acceptedFormats = field?.options?.componentsOptions?.acceptedFormats;
    if (acceptedFormats?.length > 0) {
      const tooltip = field?.options?.tooltip;
      const isAcceptedFormat = acceptedFormats.includes(file.type);
      if (!isAcceptedFormat) {
        message.error(tooltip);
      }
      return isAcceptedFormat || Upload.LIST_IGNORE;
    }
    return true;
  };

  const handleBeforeUpload = async (file: File) => {
    const isValid = checkFormats(file);
    if (!isValid) {
      throw new Error('Invalid file format');
    }
  };

  const fileProps = {
    action: '#',
    onChange: handleChange,
    customRequest: handleUpload,
    beforeUpload: handleBeforeUpload,
    fileList,
    multiple: true,
    maxCount: 1,
    disabled,
  };

  const result = (
    <>
      <Upload {...fileProps}>
        <Button disabled={disabled} icon={<UploadOutlined />}>
          上传
        </Button>
      </Upload>
    </>
  );
  return result;
};
export default memo(UploadRenderItem);
